<template>
    
    <!-- Modal -->
    <div class="modal fade" id="PostModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ post.title }}</h5>
        </div>
        <div class="modal-body">
            {{ post.content }}
        </div>
        <div class="modal-footer">
            <button type="button" @click="clean" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        </div>
    </div>
    </div>

</template>

<script>
export default {
    props: ["post"],
    created() {
        //setTimeout(function(){ $("#PostModal").modal("show"); },3000)
    },
    watch: {
        post: function(newVal, oldVal){
            $("#PostModal").modal("show");
        }
    },
    methods: {
        clean: function(){
            this.$emit('closeModalPost');
        }
    },
}
</script>